const Pagination = (props) => {
  if (props.hidden) {
    return null;
  }

  return (
    <div className="event-pagination-wrap toolbar-products">
      <nav className="event-pagination-nav" aria-label="Page navigation">
        {props.children}
      </nav>
    </div>
  );
};

export default Pagination;
